export default __webpack_public_path__ + "static/media/pantry2-before2-768w.57375226.png";